// Good to know: The Splide settings for the announcement ticket are set in announcement-ticker.liquid

class AnnouncementTicker extends HTMLElement {
  constructor() {
    super();

    this.splide;
  }

  connectedCallback() {
    this.initialise();
  }

  disconnectedCallback() {
    this.terminate();
  }

  initialise() {
    const splideEl = this.querySelector(".splide");

    this.splide = new Splide(splideEl);

    this.splide.mount(window.splide.Extensions);

    document.addEventListener("shopify:section:select", (e) => {
      const eventTargetId = e.detail.sectionId;
      if (eventTargetId !== this.id) return;

      this.pauseTicker();
    });

    document.addEventListener("shopify:section:deselect", (e) => {
      const eventTargetId = e.detail.sectionId;
      if (eventTargetId !== this.id) return;

      this.resumeTicker();
    });
  }

  /**
   * Destroys the slider, and removes the event listeners.
   */
  terminate() {
    this.splide.destroy();
  }

  /**
   * Pauses the slider.
   */
  pauseTicker() {
    this.splide.Components.AutoScroll.pause();
  }

  /**
   * Resumes the slider.
   */
  resumeTicker() {
    this.splide.Components.AutoScroll.play();
  }
}

customElements.define("announcement-ticker", AnnouncementTicker);
